import {
  CONSENT_CATEGORIES,
  type ConsentCategory,
  type ConsentChoices,
} from "./consent-record";

/** First-party cookies each service documents. Third-party ones (doubleclick.net, facebook.com) are out of reach. */
const COOKIE_PATTERNS: Readonly<Record<ConsentCategory, readonly RegExp[]>> = {
  statistics: [/^_ga$/, /^_ga_/, /^_gid$/, /^_gat/],
  google_ads: [/^_gcl_/],
  meta: [/^_fbp$/, /^_fbc$/],
};

function expireCookie(name: string): void {
  const parts: string[] = window.location.hostname.split(".");
  for (let i = 0; i < parts.length - 1; i += 1) {
    document.cookie = `${name}=; Max-Age=0; path=/; domain=.${parts.slice(i).join(".")}`;
  }
  document.cookie = `${name}=; Max-Age=0; path=/`;
}

/** Deletes cookies of every category without consent. Null choices = nothing granted. */
export function deleteUnconsentedCookies(choices: ConsentChoices | null): void {
  if (typeof document === "undefined") return;
  const names: string[] = document.cookie
    .split(";")
    .map((pair) => pair.split("=")[0]?.trim() ?? "")
    .filter((name) => name.length > 0);
  for (const category of CONSENT_CATEGORIES) {
    if (choices?.[category] === true) continue;
    for (const name of names) {
      if (COOKIE_PATTERNS[category].some((pattern) => pattern.test(name))) {
        expireCookie(name);
      }
    }
  }
}
